import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-tint text-ink" data-id="element-26" data-mp="gx6poafu4kc1">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-27" data-mp="vt60vty8r0le">
        <h2 id="bonos" className="font-display text-3xl font-extrabold leading-none tracking-tight sm:text-4xl" data-id="element-28" data-mp="qu2y6g5qh6gl">
          <span className="rounded-lg bg-coral px-2 py-0.5 text-white" data-id="element-29" data-mp="14s9lj2d23o20">
            🎁 5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-xl text-sm leading-snug text-muted" data-id="element-30" data-mp="zsna8ygsghvu">
          Y además recibes 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-teal-hover" data-id="element-31" data-mp="19jrfv7kkqqe0">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-32" data-mp="1nkvg7jc898l0">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col overflow-hidden rounded-xl border-2 border-coral bg-surface text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-33" data-mp="1jjryeramd2h5" data-mpi={i}>
              <span className="bg-coral px-2.5 py-1 font-sub text-sm font-semibold text-white" data-id="element-34" data-mp="2kb1712ln2sv">
                🎁 Bono {i + 1} — Gratis
              </span>
              <div className="flex flex-1 flex-col p-2.5" data-id="element-35" data-mp="ckld8icwe46g">
                <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-36" data-mp="chz62jtx5qor">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-muted sm:text-sm" data-id="element-37" data-mp="lblrbg0i3bjp">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-xs font-bold text-muted" data-id="element-38" data-mp="qaov6x4qvbq3">
                  Valor: <span className="line-through decoration-2" data-id="element-39" data-mp="vbcj39xofcg3">{bono.value}</span>
                </p>
              </div>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-coral bg-ink px-3 py-2.5 leading-tight" data-id="element-40" data-mp="akz7y5xddane">
          <p className="font-sub text-base font-semibold text-white" data-id="element-41" data-mp="5mnxpu35wy4n">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-gold line-through decoration-2" data-id="element-42" data-mp="kc3ld17ecng4">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-display text-sm font-extrabold uppercase text-coral" data-id="element-43" data-mp="fjahefjr5j53">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}